import { render, staticRenderFns } from "./ManageFundingFile.vue?vue&type=template&id=ab2dfb3a&scoped=true"
import script from "./ManageFundingFile.vue?vue&type=script&lang=ts"
export * from "./ManageFundingFile.vue?vue&type=script&lang=ts"
import style0 from "./ManageFundingFile.vue?vue&type=style&index=0&id=ab2dfb3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2dfb3a",
  null
  
)

export default component.exports